import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { setItem } from 'utils/localStorage';
import { getRequestsCoach, addConversation, getdivisionstudents, getfilterbasedstudents } from 'services/dashboard.service';
import { getCoach } from 'services/coachProfile.service';
import { SUCCESSFUL } from 'components/CoachRegistration/actionTypes';

import {
    ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL,
} from 'containers/PublicAthletePage/actionTypes';


import {
    PUBLIC_ADD_CONVERSATION_REQUESTED,
    PUBLIC_ADD_CONVERSATION_FAILED,
    PUBLIC_ADD_CONVERSATION_SUCCESSFUL,
} from 'containers/AthleteById/actionTypes';

import {
    REQUEST_REQUESTED,
    REQUEST_FAILED,
    REQUEST_SUCCESSFUL,
    ADD_CONVERSATION_REQUESTED,
    ADD_CONVERSATION_FAILED,
    ADD_CONVERSATION_SUCCESSFUL,
    COACH_PROFILE_REQUESTED,
    COACH_PROFILE_FAILED,
    COACH_PROFILE_SUCCESSFUL,
    DIVISION_STUDENT_FAILED,
    DIVISION_STUDENT_REQUESTED,
    DIVISION_STUDENT_SUCCESSFUL,
    FILTER_DIVISION_STUDENT_FAILED,
    FILTER_DIVISION_STUDENT_REQUESTED,
    FILTER_DIVISION_STUDENT_SUCCESSFUL,
} from './actionTypes';


export function getAllRequests(id) {
  return (dispatch) => {
    dispatch({
      type: REQUEST_REQUESTED,
    });
    getRequestsCoach(id)
        .then((result) => {
          dispatch({
            type: REQUEST_SUCCESSFUL,
            data: fromJS(result),
          });
        })
        .catch((err) => {
          dispatch({
            type: REQUEST_FAILED,
            error: err,
          });
        });
  };
}

export function updateConversation(convo, place) {
  return (dispatch) => {
    dispatch({
      type: PUBLIC_ADD_CONVERSATION_REQUESTED,
    });
    dispatch({
      type: ADD_CONVERSATION_REQUESTED,
    });
    addConversation(convo, place)
            .then((result) => {
              dispatch({
                type: PUBLIC_ADD_CONVERSATION_SUCCESSFUL,
                data: fromJS(result),
              });
              dispatch({
                type: ADD_CONVERSATION_SUCCESSFUL,
                data: fromJS(result),
              });
              dispatch({
                type: ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL,
                data: fromJS(result),
              });
            })
            .catch((err) => {
              dispatch({
                type: PUBLIC_ADD_CONVERSATION_FAILED,
                error: err,
              });
              dispatch({
                type: ADD_CONVERSATION_FAILED,
                error: err,
              });
            });
  };
}

export function getCoachProfile(id) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: COACH_PROFILE_REQUESTED,
    });
    getCoach(id)
            .then((result) => {
              if (result.profile_image !== undefined) {
                setItem('profile_image', result.profile_image);
              } else {
                setItem('profile_image', '');
              }
              dispatch({
                type: COACH_PROFILE_SUCCESSFUL,
                data: fromJS(result),
              });
              dispatch({
                type: SUCCESSFUL,
                data: fromJS(result),
              });
            })
            .catch((err) => {
              dispatch({
                type: COACH_PROFILE_FAILED,
                error: err,
              });
            });
  };
}


export function getDivisionStudents() {
  return (dispatch) => {
    dispatch({
      type: DIVISION_STUDENT_REQUESTED,
    });
    getdivisionstudents()
      .then((result) => {
        dispatch({
          type: DIVISION_STUDENT_SUCCESSFUL,
          data: fromJS(result),
        });
      })
      .catch((err) => {
        dispatch({
          type: DIVISION_STUDENT_FAILED,
          error: err,
        });
      });
  };
}

export function getFilteredDivisionStudents(payload) {
  return (dispatch) => {
    dispatch({
      type: FILTER_DIVISION_STUDENT_REQUESTED,
    });
    getfilterbasedstudents(payload)
      .then((result) => {
        dispatch({
          type: FILTER_DIVISION_STUDENT_SUCCESSFUL,
          data: fromJS(result),
        });
      })
      .catch((err) => {
        dispatch({
          type: FILTER_DIVISION_STUDENT_FAILED,
          error: err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/containers/DashBoardCoach/actions.js